"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Element = void 0;
const react_1 = __importDefault(require("react"));
function Element({ attributes, children, element, }) {
    switch (element.type) {
        case 'block-quote':
            return react_1.default.createElement("blockquote", { ...attributes }, children);
        case 'bulleted-list':
            return react_1.default.createElement("ul", { ...attributes }, children);
        case 'heading-one':
            return react_1.default.createElement("h1", { ...attributes }, children);
        case 'heading-two':
            return react_1.default.createElement("h2", { ...attributes }, children);
        case 'list-item':
            return react_1.default.createElement("li", { ...attributes }, children);
        case 'numbered-list':
            return react_1.default.createElement("ol", { ...attributes }, children);
        default:
            return react_1.default.createElement("p", { ...attributes }, children);
    }
}
exports.Element = Element;
//# sourceMappingURL=element.js.map